
const CellTDEmployeeDetail: React.FC<{ data: any }> = ({ data }) => {

    return (
        <>{data['assign_to_name']}<br /><small>{data['assign_to_phone']}</small></>
    )
}

export default CellTDEmployeeDetail;